import constants from './constants';

export default {
  bodyBg: '#000000',
  colors: {
    primary: '#261443',
    secondary: '#77372A',
    accent: '#FFFE88'
  },
  textColors: {
    primary: '#FAFAFA',
    secondary: '#261443'
  },
  fonts: {
    primary: `'Roboto Slab', serif`
  },
  shadows: ['0 0 10px rgba(99,18,118,0.5)', '0 3px 10px rgba(99,18,118,0.6)'],
  shadowColor: 'rgba(99,18,118,0.5)',
  ...constants
};
